import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Epic%20fantasy%20battle%20scene%20in%20manga%20art%20style%2C%20silhouette%20of%20warriors%20clashing%20against%20gods%20in%20golden%20arena%2C%20dramatic%20lighting%20with%20warm%20amber%20and%20deep%20crimson%20tones%2C%20cinematic%20wide%20composition%2C%20stylized%20Japanese%20comic%20illustration%2C%20epic%20scale%20with%20atmospheric%20particles%2C%20no%20text&width=1800&height=900&seq=hero-manga-bg&orientation=landscape"
        alt="终末的女武神"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 mb-4 tracking-wide">
          终末的女武神
        </h1>
        <p className="text-sm md:text-lg text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
          众神决定消灭人类，女武神提出"诸神黄昏"——13场人类对神的生死决斗。
          吕布、亚当、佐佐木小次郎……人类史上最强的战士们，为了人类的存亡而战！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <button
            onClick={() => navigate('/category')}
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-read-line mr-2 w-4 h-4 inline-flex items-center justify-center"></i>
            开始阅读
          </button>
          <button
            onClick={() => navigate('/about')}
            className="px-8 py-3 border border-background-200/60 text-background-50 rounded-md font-medium text-sm hover:bg-background-50/10 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-information-line mr-2 w-4 h-4 inline-flex items-center justify-center"></i>
            了解更多
          </button>
        </div>
        <div className="flex items-center justify-center gap-6 mt-10 text-xs md:text-sm text-background-300">
          <span className="flex items-center gap-1">
            <i className="ri-fire-line text-primary-400 w-4 h-4 flex items-center justify-center"></i>
            1.2亿次阅读
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-book-open-line text-primary-400 w-4 h-4 flex items-center justify-center"></i>
            95话连载中
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-primary-400 w-4 h-4 flex items-center justify-center"></i>
            评分 9.7
          </span>
        </div>
      </div>
    </section>
  );
}